import React from 'react';
import './Dna24Logo.css';

// Option C : logo officiel (PNG détouré) animé par effets globaux.
// - Apparition en fondu + léger zoom arrière (« gros plan qui recule »).
// - Reflet brillant qui balaie le logo (brillance), masqué sur la forme du logo.
const LOGO_SRC = '/dna/dna24-logo.png';

const Dna24Logo = ({ className = '', play = true }) => {
  return (
    <div
      className={`dna24-logo${play ? ' dna24-logo--play' : ''} ${className}`}
      data-testid="dna24-animated-logo"
    >
      <img className="dna24-logo__img" src={LOGO_SRC} alt="DNA24 — Assurance et assistance dans le monde" />
      <span className="dna24-logo__shine" style={{ '--logo': `url(${LOGO_SRC})` }} aria-hidden="true" />
    </div>
  );
};

export default Dna24Logo;
